import { IntegrationsPageHeader } from "@/pages/integrations/integrations-page-header";
import { StyledPageWrapper } from "@/pages/integrations/shared/integrations.styles";
import { IntegrationsTextMessagePageContent } from "@/pages/integrations/text-message/integrations-text-message-page-content";
import { observer } from "mobx-react-lite";
import { FC, useState } from "react";
import { useTimeout } from "usehooks-ts";

type TProps = {};

export const IntegrationsTextMessagePage: FC<TProps> = observer(() => {
  const [ready, setReady] = useState(false);

  useTimeout(() => {
    setReady(true);
  }, 100);

  return (
    <StyledPageWrapper visible={ready}>
      <IntegrationsPageHeader />
      <IntegrationsTextMessagePageContent />
    </StyledPageWrapper>
  );
});
